import setup_communications_carousel from './libraries/communications-carousel.js';

Promise.all([]).then(() => {
  setup();
  document.addEventListener("remount:homepage", remount);
});

function setup() {
  remount();
}

function remount() {
  setup_communications_carousel();
  setup_video_controls();
  setup_social_sharing();
}

function setup_social_sharing() {
    // Handle share button dropdown toggle
    var shareButton = document.getElementById('social-video-share');
    var shareContainer = shareButton ? shareButton.closest('.video-share-button-container') : null;
    var shareDropdown = shareContainer ? shareContainer.querySelector('.social-share-dropdown') : null;

    if (shareButton && shareDropdown && shareContainer) {
        // Toggle dropdown on button click
        shareButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            shareContainer.classList.toggle('show-dropdown');
            // Update aria-expanded to match dropdown state
            var isExpanded = shareContainer.classList.contains('show-dropdown');
            shareButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });

        // Prevent closing dropdown when clicking inside it
        shareDropdown.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!shareContainer.contains(e.target)) {
                shareContainer.classList.remove('show-dropdown');
                // Update aria-expanded when closing
                shareButton.setAttribute('aria-expanded', 'false');
            }
        });

        // Close dropdown when a share link is clicked
        var shareLinks = shareDropdown.querySelectorAll('a');
        shareLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                shareContainer.classList.remove('show-dropdown');
                // Update aria-expanded when closing
                shareButton.setAttribute('aria-expanded', 'false');
            });
        });
    }
}

function setup_video_controls() {
  const video = document.getElementById('social-video');
  const playBtn = document.getElementById('social-video-play');
  const volumeSlider = document.getElementById('social-video-volume');
  const muteBtn = document.getElementById('social-video-mute');

  // Quit now if these don't exist
  if (!video || !playBtn || !volumeSlider || !muteBtn) return;

  const videoContainer = video.closest('.social');
  
  let previousVolume = 50;
  let videoInitialized = false;
  let userManuallyStopped = false; // Track if user manually stopped video
  let hasResumedAfterScroll = false; // Track if we've already resumed once after manual stop

  // Use Intersection Observer to detect when video is visible (60% threshold)
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.6) {
          // Video is at least 60% visible
          if (!videoInitialized) {
            // First time visible
            videoInitialized = true;
            userManuallyStopped = false;
            hasResumedAfterScroll = false;
            video.setAttribute('autoplay', '');
            video.play().catch(() => {
              // Autoplay might be blocked, that's okay
            });
            initializeVideoControls();
          } else if (userManuallyStopped && !hasResumedAfterScroll) {
            // User manually stopped it, but scrolled back with 60% visible
            // Do NOT auto-resume - wait for manual click
          } else if (!userManuallyStopped && video.paused) {
            // Video was auto-paused by scrolling off, now scrolling back on
            video.play().catch(() => {});
            hasResumedAfterScroll = true;
          }
        } else if (entry.intersectionRatio === 0) {
          // Video is 100% scrolled off screen - pause it if not manually stopped
          if (!userManuallyStopped) {
            video.pause();
            hasResumedAfterScroll = false; // Reset so we can resume again if scrolled back
          }
        }
      });
    },
    { threshold: [0, 0.6] } // Track at 0% and 60%
  );

  observer.observe(video);

  function initializeVideoControls() {
    // Play/pause button click
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        userManuallyStopped = false;
        playBtn.classList.remove('mejs-play');
        playBtn.classList.add('mejs-pause');
      } else {
        video.pause();
        userManuallyStopped = true;
        playBtn.classList.remove('mejs-pause');
        playBtn.classList.add('mejs-play');
      }
    });

    // Play/pause on video click (anywhere on video)
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        userManuallyStopped = false;
        playBtn.classList.remove('mejs-play');
        playBtn.classList.add('mejs-pause');
      } else {
        video.pause();
        userManuallyStopped = true;
        playBtn.classList.remove('mejs-pause');
        playBtn.classList.add('mejs-play');
      }
    });

    // Update button icon when video state changes
    video.addEventListener('play', () => {
      playBtn.classList.remove('mejs-play');
      playBtn.classList.add('mejs-pause');
    });

    video.addEventListener('pause', () => {
      playBtn.classList.remove('mejs-pause');
      playBtn.classList.add('mejs-play');
    });

    // Volume slider
    volumeSlider.addEventListener('input', (e) => {
      const volume = e.target.value / 100;
      video.volume = volume;
      previousVolume = e.target.value;
      volumeSlider.style.setProperty('--volume-level', e.target.value);
      
      // Unmute if volume is increased
      if (volume > 0 && video.muted) {
        video.muted = false;
        muteBtn.classList.remove('mejs-mute');
        muteBtn.classList.add('mejs-unmute');
        updateVolumeControlVisibility();
      }
    });

    // Initialize volume level
    volumeSlider.style.setProperty('--volume-level', volumeSlider.value);

    // Mute button
    muteBtn.addEventListener('click', () => {
      if (video.muted) {
        video.muted = false;
        video.volume = previousVolume / 100;
        volumeSlider.value = previousVolume;
        volumeSlider.style.setProperty('--volume-level', previousVolume);
        muteBtn.classList.remove('mejs-mute');
        muteBtn.classList.add('mejs-unmute');
      } else {
        previousVolume = volumeSlider.value;
        video.muted = true;
        muteBtn.classList.remove('mejs-unmute');
        muteBtn.classList.add('mejs-mute');
      }
      updateVolumeControlVisibility();
    });

    // Update volume control visibility based on mute state
    function updateVolumeControlVisibility() {
      if (video.muted) {
        videoContainer.classList.add('is-muted');
      } else {
        videoContainer.classList.remove('is-muted');
      }
    }

    // Initialize mute button state and volume control visibility
    if (video.muted) {
      muteBtn.classList.add('mejs-mute');
      volumeSlider.value = 0;
      volumeSlider.style.setProperty('--volume-level', 0);
      videoContainer.classList.add('is-muted');
    } else {
      muteBtn.classList.add('mejs-unmute');
      volumeSlider.style.setProperty('--volume-level', volumeSlider.value);
      videoContainer.classList.remove('is-muted');
    }
  }
}
